import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Panel } from '../../../components/layout/layout';
import VerticalBars from '../../../components/charts/chartjs/sonar-vertical-bars/SonarVerticalBars';
import { SONAR_DATA_KEYS } from '../../../utils/chart';

import scss from './BrandGraph.module.scss';

function BrandGraph({ chosenDomain }) {
  const { t } = useTranslation('sonar');

  const data = useMemo(() => domainEntryToBrandChartData(chosenDomain, t), [chosenDomain, t]);

  return (
    <div className={scss.sectionWrapper}>
      <h4 className={scss.chartSectionTitle}>Sonar</h4>

      <Panel>
        <VerticalBars
          data={data}
          dataKey='values'
          title={chosenDomain.label || chosenDomain.domain}
          height={'500px'}
          customTooltip
          showScore
          showTrend
        />
      </Panel>
    </div>
  );
}

export default BrandGraph;

export const SONAR_STATS_NAMES = {
  [SONAR_DATA_KEYS.INTEREST]: 'interest',
  [SONAR_DATA_KEYS.TRUST]: 'trust',
  [SONAR_DATA_KEYS.PASSION]: 'engagement',
  [SONAR_DATA_KEYS.POWERRANK]: 'powerrank',
  [SONAR_DATA_KEYS.PRESENCE]: 'presence',
  [SONAR_DATA_KEYS.RELEVANCE_STRENGTH]: 'relevanceStrength',
  [SONAR_DATA_KEYS.RELEVANCE_BREADTH]: 'relevanceBreadth',
  [SONAR_DATA_KEYS.FRICTION]: 'rivalry',
  [SONAR_DATA_KEYS.ENERGY]: 'vitality',
};

export const domainEntryToBrandChartData = (domainEntry, t) => {
  const res = Object.values(SONAR_DATA_KEYS).map((stat) => ({
    domain: t(SONAR_STATS_NAMES[stat]),
    label: t(SONAR_STATS_NAMES[stat]),
    companyLogo: '',
    values: {
      score: domainEntry[stat]?.score || 0,
      trend: domainEntry[stat]?.trend || 0,
    },
  }));

  return res;
};
